
import { Box, ToggleButton, ToggleButtonGroup, useTheme } from "@mui/material";
import cx from 'classnames';
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useGridFilter } from "../../../../../contexts/GridFilterContext";
import { updateFilter } from "../../../../../newapi/global/filter/gridFilterSlice";
import { tokens } from "../../../../../theme";
import { RETURNLINE_FILTER_KEYS } from "../../Filter";

const LineWithAcceptedCount = () => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const {t} = useTranslation();
    const filterKey = RETURNLINE_FILTER_KEYS.ACCEPTED_COUNT.backend_key;
    const dispatch = useDispatch();

    const { index,id } = useGridFilter();
    const filterObject = useSelector((state) => {
        const instance = state.gridFilter.viewInstances[index];
        return instance ? instance[id] : undefined;
    });

    const handleStateToggle = (itemState) => {
        if (filterObject && filterObject.filter) {
            dispatch(updateFilter({ index, id, filterKey, value: itemState }));
        }
    };
  
    return (
        <Box
            sx={{
                display:"flex",
                flexDirection:"column",
                gap:1.5,
            }}
        >
            <ToggleButtonGroup
                color={filterObject.filter?.[filterKey] ? "green" : "red"}
                value={filterObject.filter?.[filterKey]}
                exclusive
                onChange={() => {
                    if(typeof filterObject.filter?.[filterKey] === "undefined" || filterObject.filter?.[filterKey] === false) {
                        handleStateToggle(true);
                    } else {
                        handleStateToggle(false);
                    }
                }}
                aria-label="Active"

                className={cx(`${filterObject.filter?.[filterKey]}`, {
                    'active': !filterObject.filter?.[filterKey] 
                })}
                sx={{

                    background: theme.palette.mode === "dark" ? colors.blue[100] : colors.primary[100],
                    padding:0.5,
                    borderRadius:5,
                    transition:"250ms",
                    "&.active" : {
                        background: colors.grey[100],
                        transition:"250ms",
                    },
                    "@media screen and (max-width: 47.9375em)" : {
                        display:"none",
                    }
                }}
            >
                <ToggleButton
                    sx={{
                        flex:1,
                        padding: 0,
                        paddingX: 2,
                        border: 0,
                        lineHeight: "32px",
                        textTransform: "unset",
                        borderRadius: "32px !important",
                        color:!filterObject.filter?.[filterKey]  ?"#fff":  theme.palette.mode === "dark" ? colors.blue[400] : colors.primary[400],  // White text
                        background: !filterObject.filter?.[filterKey]  ? colors.grey[400] : "transparent", // Red background if inactive
                        transition: "250ms",
                        "&.Mui-selected": {
                            background: colors.grey[400], 
                            color: "#fff", 
                            fontWeight:"bold",
                        },
                        "&.Mui-selected:hover": {
                            background:theme.palette.mode === "dark" ? colors.grey[600]: "#1F293D",
                        },
                    }}
                    value={false}
                >
                    {t('all')}
                </ToggleButton>
                <ToggleButton
                    sx={{
                        flex:1,
                        padding: 0,
                        paddingX: 2,
                        border: 0,
                        lineHeight: "32px",
                        textTransform: "unset",
                        borderRadius: "32px !important",
                        color: theme.palette.mode === "dark" ? colors.txt["secondary"] : colors.grey[400], 
                        background: filterObject.filter?.[filterKey] ?  theme.palette.mode === "dark" ? colors.blue[400] : colors.primary[400] : "transparent", 
                        transition: "250ms",
                        "&.Mui-selected": {
                            background:  theme.palette.mode === "dark" ? colors.blue[400] : colors.primary[400], 
                            color: theme.palette.mode === "dark" ? colors.txt["primaryDark"] :  colors.txt["white"], 
                            fontWeight:"bold",
                        },
                        "&.Mui-selected:hover": {
                            background:theme.palette.mode === "dark" ? "#A8C7FF" : "#0055F5"
                        },
                    }}
                    value={true}
                >
                    {t('only_with_accepted')}
                </ToggleButton>
            </ToggleButtonGroup>
        </Box>
    );
};

export default LineWithAcceptedCount;